<template>
    <v-card
        class="pa-3"
        style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
    >
        <div class="headline pl-0 mb-3 pr-3 text-xs-right">Therapy</div>

        <v-layout row class="ma-0 pa-0">
            <v-layout column class="ma-1 px-3 mt-2" justify-end align-end>
                <div class="text-xs-right">
                    <div class="font-weight-medium">
                        ארטס און קרעפטס<span class="caption mr-1"
                            >קען אליין'ס מאכן</span
                        >
                    </div>
                    <v-radio-group
                        class="mt-1"
                        v-model="therapyInfo.artsAndCrafts"
                        row
                    >
                        <v-radio
                            label="ניין"
                            value="ניין"
                            color="success"
                        ></v-radio>
                        <v-radio
                            label="אביסל"
                            value="אביסל"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="mr-0"
                            label="יא"
                            value="יא"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </div>

                <div class="text-xs-right">
                    <div class="font-weight-medium">
                        וויאזוי האט ער אנגעצייכנט די א' ב' צעטיל
                    </div>
                    <v-radio-group
                        class="mt-1"
                        v-model="therapyInfo.alphabet"
                        row
                    >
                        <v-radio
                            label="נישט גוט"
                            value="נישט גוט"
                            color="success"
                        ></v-radio>
                        <v-radio
                            label="אביסל גוט"
                            value="אביסל גוט"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="mr-0"
                            label="גוט"
                            value="גוט"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </div>
                <div class="text-xs-right">
                    <div class="font-weight-medium">
                        שלעפט ער זיך נאך אדער גייט געהעריג
                    </div>
                    <v-radio-group
                        class="mt-1"
                        v-model="therapyInfo.walking"
                        row
                    >
                        <v-radio
                            label="נישט גוט"
                            value="נישט גוט"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="mr-0"
                            label="גייט גוט"
                            value="גייט גוט"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </div>

                <div class="text-xs-right">
                    <div class="font-weight-medium">
                        גייט דאס קינד צו טערעפי
                    </div>
                    <v-radio-group
                        class="mt-1"
                        v-model="therapyInfo.therapy"
                        row
                    >
                        <v-radio
                            label="ניין"
                            value="ניין"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="mr-0"
                            label="יא"
                            value="יא"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </div>

                <div class="text-xs-right">
                    <v-text-field
                        class="mt-0 pt-0 text-xs-right"
                        style="min-width: 320px;"
                        v-model="therapyInfo.otherConcerns"
                        label="וועגן קינד
Concerns
אנדערע
"
                        hide-details
                        reverse
                    ></v-text-field>
                </div>

                <div class="text-xs-right">
                    <v-text-field
                        class="mt-1 mb-3"
                        style="min-width: 320px;"
                        v-model="therapyInfo.calledParents"
                        label="גערופן די עלטערן"
                        hide-details
                        reverse
                    ></v-text-field>
                </div>
            </v-layout>

            <v-layout column class="ma-1 px-3 mt-2" justify-end align-end>
                <div class="text-xs-right">
                    <div class="font-weight-medium">
                        זיצט שיין<span class="caption mr-1"
                            >ווען די רבי דערציילט</span
                        >
                    </div>
                    <v-radio-group
                        class="mt-1"
                        v-model="therapyInfo.seating"
                        row
                    >
                        <v-radio
                            label="נישט שיין"
                            value="נישט שיין"
                            color="success"
                        ></v-radio>
                        <v-radio
                            label="אביסל שיין"
                            value="אביסל שיין"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="mr-0"
                            label="שיין"
                            value="שיין"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </div>
                <div class="text-xs-right">
                    <div class="font-weight-medium">
                        פאלגט נאך אנווייזונגען<span class="caption mr-1"
                            >ברענג מיר א לעגא</span
                        >
                    </div>
                    <v-radio-group
                        class="mt-1"
                        v-model="therapyInfo.follwingInstructions"
                        row
                    >
                        <v-radio
                            label="נישט גוט"
                            value="נישט גוט"
                            color="success"
                        ></v-radio>
                        <v-radio
                            label="אביסל גוט"
                            value="אביסל גוט"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="mr-0"
                            label="גוט"
                            value="גוט"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </div>

                <div class="text-xs-right">
                    <div class="font-weight-medium">
                        רעדט קלאר<span class="caption mr-1"
                            >אז אנדערע זאלן פארשטיין</span
                        >
                    </div>
                    <v-radio-group
                        class="mt-1"
                        v-model="therapyInfo.speaking"
                        row
                    >
                        <v-radio
                            label="נישט גוט"
                            value="נישט גוט"
                            color="success"
                        ></v-radio>
                        <v-radio
                            label="אביסל גוט"
                            value="אביסל גוט"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="mr-0"
                            label="גוט"
                            value="גוט"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </div>

                <div class="text-xs-right">
                    <div class="font-weight-medium">קאלירט שיין</div>
                    <v-radio-group
                        class="mt-1"
                        v-model="therapyInfo.coloring"
                        row
                    >
                        <v-radio
                            label="נישט שיין"
                            value="נישט שיין"
                            color="success"
                        ></v-radio>
                        <v-radio
                            label="אביסל שיין"
                            value="אביסל שיין"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="mr-0"
                            label="שיין"
                            value="שיין"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </div>

                <div class="text-xs-right">
                    <div class="font-weight-medium">
                        ציילן<span class="caption mr-1">גיב מיר 5 לעגאס</span>
                    </div>
                    <v-radio-group
                        class="mt-1"
                        v-model="therapyInfo.counting"
                        row
                    >
                        <v-radio
                            label="קען נישט"
                            value="קען נישט"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="mr-0"
                            label="גוט"
                            value="גוט"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </div>

                <div class="text-xs-right">
                    <div class="font-weight-medium">
                        שפילן<span class="caption mr-1"
                            >שפילט אליין – שטערט אנדערע</span
                        >
                    </div>
                    <v-layout row class="pa-0">
                        <v-radio-group
                            class="mt-1"
                            v-model="therapyInfo.playingShtert"
                            row
                        >
                            <v-radio
                                label="ניין"
                                value="ניין"
                                color="success"
                            ></v-radio>
                            <v-radio
                                class="mr-0"
                                label="יא"
                                value="יא"
                                color="success"
                            ></v-radio>
                        </v-radio-group>
                        <div class="ml-2 mr-0 pt-1">שטערט</div>
                        <div class="mx-2"></div>
                        <v-radio-group
                            class="mt-1"
                            v-model="therapyInfo.playingAlone"
                            row
                        >
                            <v-radio
                                label="ניין"
                                value="ניין"
                                color="success"
                            ></v-radio>
                            <v-radio
                                class="mr-0"
                                label="יא"
                                value="יא"
                                color="success"
                            ></v-radio>
                        </v-radio-group>
                        <div class="ml-2 mr-0 pt-1">שפילט אליין</div>
                    </v-layout>
                </div>
            </v-layout>
        </v-layout>

        <v-card-actions class="pb-0 mt-2">
            <v-btn :loading="processing" color="success" @click="save()"
                >Save</v-btn
            >
            <v-btn color="default" dark @click="close">Cancel</v-btn>
            <v-spacer></v-spacer>
        </v-card-actions>
    </v-card>
</template>
<script>
import moment from "moment";

export default {
    props: {
        therapyInfo: Object,
        student: Object,
        close: Function,
    },
    data: () => ({
        processing: false,

        rules: {
            required: (v) => {
                return !!v || "Required";
            },
        },
    }),
    async created() {},
    methods: {
        async save() {
            try {
                this.processing = true;

                const therapyInfo = this.therapyInfo;

                therapyInfo.studentID = this.student.studentID;
                therapyInfo.updatedBy = this.$store.state.authentication.user;
                therapyInfo.updatedOn = moment().format("YYYY-MM-DD HH:mm:ss");

                await this.$http.post("api/studentsTherapy/save", therapyInfo);

                this.processing = false;

                this.close();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style></style>
